import React from "react";
import { Box } from "@material-ui/core";
import { boxShadow, colors } from "swyft-react-core";
import { QuoteHr } from "./components/QuoteHr";
import { TF } from "../../components/typography/TF";

export const QuoteComments = ({ comments }: Props) => {
  if (comments === null || comments === "") {
    return null;
  }

  return (
    <Box id="QuoteComments" boxShadow={boxShadow} bgcolor={colors.white} p={3} height="100%">
      <TF variant="h5" bold paragraph>
        Assessment Comments
      </TF>
      <QuoteHr />
      <Box mt={2}>
        <TF component="div">
          {comments?.split("\n").map((i, key) => {
            return <div key={key}>{i}</div>;
          })}
        </TF>
      </Box>
    </Box>
  );
};

interface Props {
  comments?: string;
}
